import React from 'react'
import Button from './button'
import "./stylesheet/education.css"
const certi=[
  {
    title:"Certificates In css 3",
    provider:" Hackerrank",
    link:"https://www.hackerrank.com/certificates/492f29afdf4d",
    subtext:"Verify at",
    imgLink:"url(./media/cssHr.png)"
  },
  {
    title:"Internet of Things",
    provider:"Coursera",
    link:"https://coursera.org/share/4953ced40c0e182c813b026ee1c60483",
    subtext:"Verify at",
    imgLink:"url(/media/iotcoursera.png)"
  },
  {
    title:"Introduction to Electronics",
    provider:"Coursera",
    link:"https://coursera.org/share/6dcdec39a8dc71c11553bce3068daae8",
    subtext:"verify at",
    imgLink:"url(/media/eccoursera.png)"
  },
  {
    title:"Microprocessor 8085",
    provider:"Bharat A edu.",
    link:"  https://umangsahu.github.io/media/Bharat_Acharya_Education_Graphic_Certificate_SUB2492620722.pdf    ",
    subtext:"Checkout at",
    imgLink:"url(/media/ba.png)"
  }
]
const Education = () => {
  return (
    
   <>
   <section className='education'><div className="headingp">
<div className="mainheading">Education & Certification!</div>
<div className="line"></div>
<span className="subtext"><span>
Certification is also a Good way to show  expertise  in perticular skill here is my certificates.</span></span>

   </div>
   <div className="certi-cards">
    {
      certi.map((currelem)=>{
        return(
<div className="certicard">
    <div className="card-img" style={{background:currelem.imgLink}}></div>
    <div className="text">
        <h3>{currelem.title}</h3>
        <span>{currelem.provider}</span>
      
    </div>
    <Button link={currelem.link} title={currelem.provider} subtext={currelem.subtext}/>
   </div>
        )
      })
    }
    </div>
    
   </section>
   </>
  )
}

export default Education